import { Component, Input } from '@angular/core';
import { Config } from '../../universal-config';

@Component({
  selector: 'nns-audio-player',
  template: `
    <div flex="none">
      <h3>{{attachment.displayName}}</h3>
      <audio
        class="nns-audio"
        [src]="fileServerUrl + attachment?.attachmentURL"
        preload="auto"
        autoplay="autoplay"
        controls="controls"
      ></audio>
      <div class="nns-attach-download" flex="none">
        <a [href]="fileServerUrl + attachment.attachmentURL + '?dw'"
          title="Download {{attachment.displayName}}"
          target="_blank">Download</a>
      </div>
    </div>
  `,
  styles: [`
    :host {
      min-width: 35vw;
    }

    .nns-audio{
      width: 100%;
    }

    h3{
      padding: 0 0 10px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }

    .nns-attach-download{
      text-align: right;
    }

    @media (max-width: 768px) {
      :host{
        min-width: 50vw;
      }
    }
    @media (max-width: 768px) {
      :host{
        min-width: 50vw;
      }
    }
    @media (max-width: 600px) {
      :host{
        min-width: 90vw;
      }
    }
  `]
})
export class AudioPlayerComponent {
  @Input() public attachment;
  fileServerUrl: string;
  constructor(
    private config: Config,
  ) {
    this.fileServerUrl = this.config.get('BOX_URL')
  }
}
